import React from 'react';
import { GiftIcon } from 'lucide-react';
export function BonusSection() {
  return <section className="w-full bg-[#f5f5f5] py-16 md:py-20 lg:py-24 px-4" data-id="element-1">
      <div className="max-w-7xl mx-auto" data-id="element-2">
        <div className="flex items-center justify-center gap-4 mb-8" data-id="element-3">
          <GiftIcon className="w-16 h-16 text-[#c41e3a]" aria-hidden="true" data-id="element-4" />
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-gray-900 text-center" data-id="element-5">
            Además, accedés a estos bonus exclusivos
          </h2>
        </div>
        <div className="w-32 h-1 bg-[#c41e3a] mx-auto mb-20" data-id="element-6"></div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16" data-id="element-7">
          {/* Bonus 1 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-lg border-4 border-gray-300" data-id="element-8">
            {/* Etiqueta BONUS 1 */}
            <div className="bg-gradient-to-r from-[#c41e3a] to-[#d91e5b] text-white text-center py-4 font-black text-2xl tracking-wider" data-id="element-9">
              BONUS 1
            </div>
            <div className="bg-gray-50 p-6" data-id="element-10">
              <img src="https://cdn.magicpatterns.com/uploads/cGJpTmyHPbpqPGVXxewqK8/bonus_1.png" alt="Bonus 1: Guía de herramientas recomendadas" className="w-full h-56 object-contain" data-id="element-11" />
            </div>
            <div className="p-10" data-id="element-12">
              <h3 className="text-gray-900 font-black text-2xl text-center mb-6 leading-tight" data-id="element-13">
                Guía Completa de Herramientas Profesionales
              </h3>
              <p className="text-gray-700 text-lg text-center leading-relaxed" data-id="element-14">
                Descubrí exactamente qué herramientas necesitás para empezar en
                barbería sin gastar de más. Recomendaciones probadas y
                específicas.
              </p>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-lg border-4 border-gray-300" data-id="element-15">
            {/* Etiqueta BONUS 2 */}
            <div className="bg-gradient-to-r from-[#d91e5b] to-[#c41e3a] text-white text-center py-4 font-black text-2xl tracking-wider" data-id="element-16">
              BONUS 2
            </div>
            <div className="bg-gray-50 p-6" data-id="element-17">
              <img src="https://cdn.magicpatterns.com/uploads/oittqwoA4ccTaW6GaGFjDn/bonus_2.png" alt="Bonus 2: Errores más comunes del barbero principiante" className="w-full h-56 object-contain" data-id="element-18" />
            </div>
            <div className="p-10" data-id="element-19">
              <h3 className="text-gray-900 font-black text-2xl text-center mb-6 leading-tight" data-id="element-20">
                Los 10 Errores Que Te Hacen Perder Clientes
              </h3>
              <p className="text-gray-700 text-lg text-center leading-relaxed" data-id="element-21">
                Evitá los errores más comunes que cometen los barberos
                principiantes. Aprendé de los errores de otros y ahorrá tiempo y
                frustraciones.
              </p>
            </div>
          </div>

          {/* Bonus 3 */}
          <div className="bg-white rounded-lg overflow-hidden shadow-lg border-4 border-gray-300" data-id="element-22">
            {/* Etiqueta BONUS 3 */}
            <div className="bg-gradient-to-r from-[#c41e3a] to-[#d91e5b] text-white text-center py-4 font-black text-2xl tracking-wider" data-id="element-23">
              BONUS 3
            </div>
            <div className="bg-gray-50 p-6" data-id="element-24">
              <img src="https://cdn.magicpatterns.com/uploads/9y1VLYc2fxYSx5JzpC7hMJ/bonus_3.png" alt="Bonus 3: Cómo conseguir clientes y generar ingresos" className="w-full h-56 object-contain" data-id="element-25" />
            </div>
            <div className="p-10" data-id="element-26">
              <h3 className="text-gray-900 font-black text-2xl text-center mb-6 leading-tight" data-id="element-27">
                Sistema Para Conseguir Tus Primeros Clientes
              </h3>
              <p className="text-gray-700 text-lg text-center leading-relaxed" data-id="element-28">
                Estrategias probadas para atraer clientes desde el día uno y
                generar ingresos reales como barbero profesional.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}